// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // The activity form (manage/services/add). false: admins do not edit a vendor's activity. See _helpers/service-edit.guard.ts.
  adminCanEditServices: false,
  apiBaseUrl: 'https://staging-api.allout.ae/admin/api/v1',
  // apiBaseUrl: 'http://3.81.136.229:8080/admin/api/v1',
  firebase: {
    apiKey: "AIzaSyDAAE27Q7HNFYKfjfuN_e3MO2lzwzwlBwc",
    authDomain: "all-out-1337f.firebaseapp.com",
    projectId: "all-out-1337f",
    storageBucket: "all-out-1337f.appspot.com",
    messagingSenderId: "168378252615",
    appId: "1:168378252615:web:b52199827be9192d872062",
    vapidKey: "BEr_kZjs7_kuMTRT5uk-6dNGb3oe1MOg1t3ej8BBQVrrX1abIvLk5OxsdFJdxE0yp8qKHUfFq_HIes5WUH1C4_k",
  },
  googleMapApiKey: 'AIzaSyB50-kXuOn3zBMljPoGNljD97gjSzV0XaI',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
